import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Layout from '../../components/Layout';
import StakeHolder from './sections/StakeHolder';
import Connection from './sections/Connection';
import Diagram from './sections/Diagram';

import { useAuth } from '../../contexts/AuthContext';
import { getAllProjects } from '../../actions/project';
import { getAllStakeholders } from '../../actions/stakeholder';
import { getAllConnections } from '../../actions/connection';

const Dashboard = () => {
  const dispatch = useDispatch();

  const { currentUser } = useAuth();

  const project = useSelector((state) => state.project.project);
  const stakeholders = useSelector((state) => state.stakeholder.stakeholders);
  const connections = useSelector((state) => state.connection.connections);

  useEffect(() => {
    if (currentUser) {
      dispatch(getAllProjects(currentUser.uid));
    }
  }, [currentUser, dispatch]);

  useEffect(() => {
    if (project) {
      dispatch(getAllStakeholders(project.id));
      dispatch(getAllConnections(project.id));
    }
  }, [project, dispatch]);

  if (!currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <Layout>
      <div className="admin-dashboard">
        <div className="admin-inner">
          <Row>
            <Col sm={12} lg={6}>
              <StakeHolder stakeholders={stakeholders} connections={connections} />
              <Connection stakeholders={stakeholders} connections={connections} />
            </Col>
            <Col sm={12} lg={6}>
              <Diagram />
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
